<div
  #container
  class="iu-modal-background"
  [attr.data-cy-contentType]="contentType"
  [hidden]="!isModalDisplay"
  [ngClass]="{ hidden: !isModalDisplay }"
  [ngStyle]="
    angularStyle !== undefined && angularStyle['iu-modal-background'] ? angularStyle['iu-modal-background'] : ''
  "
  (contextmenu)="$event.preventDefault()"
  (mousedown)="initClose($event)"
  (touchstart)="initClose($event)">
  <div
    cdkDrag
    [cdkDragBoundary]="container"
    [cdkDragDisabled]="isCompact"
    class="{{ 'iu-modal ' + modalClass }}"
    role="dialog"
    aria-modal="true"
    [attr.aria-labelledby]="title !== undefined && title !== null ? titleId : null"
    [ngStyle]="angularStyle !== undefined && angularStyle['iu-modal'] ? angularStyle['iu-modal'] : ''">
    <div
      cdkDragHandle
      [ngClass]="[title !== undefined && title !== null ? 'border' : '', 'iu-modal-header']"
      [ngStyle]="angularStyle !== undefined && angularStyle['iu-modal-header'] ? angularStyle['iu-modal-header'] : ''">
      @if (title !== undefined && title !== null) {
        <div class="title" [id]="titleId">{{ title | translate }}</div>
      }
      <div class="close-cross">
        <button
          class="btn-close iu-modal-close-btn"
          data-cy="modal-close-btn"
          type="button"
          [attr.aria-label]="'generic.close' | translate"
          [attr.title]="'generic.close' | translate"
          (click)="close($event, true)">
          <i aria-hidden="true" class="icon-close"></i>
        </button>
      </div>
      @if (isLoading) {
        <p-progressBar [mode]="'indeterminate'" [showValue]="false" [styleClass]="'loading-progressbar'" [value]="0" />
      }
    </div>

    <div
      class="iu-modal-body"
      [ngStyle]="angularStyle !== undefined && angularStyle['iu-modal-body'] ? angularStyle['iu-modal-body'] : ''">
      <ng-content />
    </div>
    @if (hasCloseBtn || hasFooter) {
      <div
        class="iu-modal-footer"
        [class.with-close]="hasCloseBtn"
        [ngStyle]="
          angularStyle !== undefined && angularStyle['iu-modal-footer'] ? angularStyle['iu-modal-footer'] : ''
        ">
        <!-- secondary (close) first, projected actions after: same visual order as before -->
        @if (hasCloseBtn) {
          <button
            class="p-button p-button-secondary"
            data-cy="modal-footer-close-btn"
            pButton
            type="button"
            label="{{ closeBtnLabel | translate }}"
            (click)="close($event, true)"></button>
        }
        <ng-content select="[footer]" />
      </div>
    }
  </div>
</div>
